<template>
    <div layout="row" flex>
        <div layout="column" class="messages-col" layout-align="start start" flex>
            <div layout="row" layout-align="start center" class="title grey--text text-uppercase full-width bg-white font-weight-medium mb2-pc mb1-mobile pt3-pc pr2-pc pl2-pc pb2-pc pr1-mobile pl1-mobile">{{$t('nav.abusive')}}
                <span flex></span>
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ma-0"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
            </div>

            <div v-if="$vuetify.breakpoint. smAndDown && displayFilters" layout="column" layout-align="start start" class="full-width bg-white mt-2 pa-2">
                <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb1-mobile mt-1">{{$t('messages.filter')}}</div>
                <v-text-field prepend-inner-icon="mdi-magnify" single-line flat v-model="filters.keywords" @keyup.enter="fetch(true)"  hide-details class="full-width" :label="$t('filters.schools_hint')"></v-text-field>

                <v-expansion-panel class="mt-3 exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('messages.msg_types')}}</div>
                    </template>
                    <v-checkbox v-for="t in types" hide-details :label="t.text" :value="t.value"
                    v-model="filters.type"  :key="`typefilter_${t.value}`" @change="fetch(true)" class="mt-0 pt-0 filter-cb text-lowercase">
                        <template slot="label">
                            <div layout="row" layout-align="start center">
                                <v-icon class="mr-2">mdi-{{t.icon}}</v-icon>
                                <span class="body-1">{{t.text}}</span>
                            </div>
                        </template>
                    </v-checkbox>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('_.date')}}</div>
                    </template>
                    <div layout="row" layout-align="start center" flex>
                        <div layout="column" layout-align="start start" class="mr-2" flex>
                            {{$t('_.from')}}
                            <v-menu ref="menu3" :close-on-content-click="false" v-model="startDatepicker2" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width class="full-width">
                                <v-text-field slot="activator" v-model="startFormatted" :label="$t('_.date_format')" single-line flat outline append-outer-icon="mdi-calendar"
                                @blur="filters.start = parseDate(filters.start)" />
                                <v-date-picker v-model="filters.start" no-title @input="startDatepicker2 = false" @change="fetch(true)" :first-day-of-week="1" :locale="_locale" />
                            </v-menu>
                        </div>
                        <div layout="column" layout-align="start start" flex>
                            {{$t('_.to')}}
                            <v-menu ref="menu4" :close-on-content-click="false" v-model="endDatepicker2" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width class="full-width">
                                <v-text-field slot="activator" v-model="endFormatted" :label="$t('_.date_format')" single-line flat outline append-outer-icon="mdi-calendar"
                                @blur="filters.end = parseDate(filters.end)" />
                                <v-date-picker v-model="filters.end" no-title @input="endDatepicker2 = false" :first-day-of-week="1" @change="fetch(true)" :locale="_locale" />
                            </v-menu>
                        </div>
                    </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('filters.sender_sectors')}}</div>
                    </template>
                    <v-checkbox v-for="s in sectors" hide-details :label="s.text" :value="s.value"
                    v-model="filters.sector"  :key="`sectorfilter_${s.value}`" @change="fetch(true)" class="mt-0 filter-cb pt-0"></v-checkbox>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('filters.sender_lvs')}}</div>
                    </template>
                    <v-checkbox v-for="l in levels" hide-details :label="l.text" :value="l.value"
                    v-model="filters.level"  :key="`levelfilter_${l.value}`" @change="fetch(true)" class="mt-0 filter-cb pt-0"></v-checkbox>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </div>

            <div class="full-width">
								<div layout="column" layout-align="start start"  class="bg-white mb2-pc mb1-mobile mt3-pc mt2-mobile pt1-mobile pt2-pc pr2-pc pl2-pc pb1-pc pr1-mobile pl1-mobile full-width">
										<div layout="row" layout-align="start center" class="font-weight-bold subheading">{{$t('messages.to_process')}}</div>
										<div v-if="!reports || !reports.length" layout="row" layout-align="start center">{{$t('messages.none')}}</div>
								</div>
                <message v-for="m in reports" :key="m.id" :message="m" class="bg-white full-width" :isReported="true" style="margin-top: 10px" @removed="fetch(true)" @deleted="fetch(true)"></message>

                <div layout="column" layout-align="start start" class="bg-white mb2-pc mb1-mobile mt2-mobile pt1-mobile mt3-pc pt2-pc pr2-pc pl2-pc pb1-pc pr1-mobile pl1-mobile full-width">
                    <div layout="row" layout-align="start center" class="font-weight-bold subheading">{{$t('messages.processed')}}</div>
                    <div v-if="!processed || !processed.length" layout="row" layout-align="start center">{{$t('messages.none')}}</div>
                </div>
                <message v-for="m in processed" :key="m.id" :message="m" class="bg-white full-width" :isReported="true" style="margin-top: 10px" @deleted="fetch(true)"></message>
            </div>

            <div v-if="loading && !noMoreData" layout="row" layout-align="center center" class="mt-3 full-width font-weight-black" style="color: #616161">
                {{$t('messages.loading')}}
            </div>
            <div v-if="loading && !noMoreData" layout="row" layout-align="center center" class="mt-2 full-width">
                <beat-loader :loading="loading && !noMoreData" color="grey"></beat-loader>
            </div>
        </div>
        <div layout="column" layout-align="start start" class="hidden-sm-and-down" style="width: 300px">
            <div layout="column" layout-align="start start" class="full-width px2-pc mb10-pc pb3-pc mb1-mobile px1-mobile bg-white">
                <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc">{{$t('messages.filter')}}</div>
                <v-text-field prepend-inner-icon="mdi-magnify" single-line flat v-model="filters.keywords" @keyup.enter="fetch(true)"  hide-details class="full-width" :label="$t('filters.schools_hint')"></v-text-field>

                <v-expansion-panel class="mt-3 exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('messages.msg_types')}}</div>
                    </template>
                    <v-checkbox v-for="t in types" hide-details :label="t.text" :value="t.value"
                    v-model="filters.type"  :key="`typefilter_${t.value}`" @change="fetch(true)" class="mt-0 pt-0 filter-cb text-lowercase">
                        <template slot="label">
                            <div layout="row" layout-align="start center">
                                <v-icon class="mr-2">mdi-{{t.icon}}</v-icon>
                                <span class="body-1">{{t.text}}</span>
                            </div>
                        </template>
                    </v-checkbox>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('_.date')}}</div>
                    </template>
                    <div layout="row" layout-align="start center" flex>
                        <div layout="column" layout-align="start start" class="mr-2" flex>
                            {{$t('_.from')}}
                            <v-menu ref="menu1" :close-on-content-click="false" v-model="startDatepicker" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width class="full-width">
                                <v-text-field slot="activator" v-model="startFormatted" :label="$t('_.date_format')" single-line flat outline append-outer-icon="mdi-calendar"
                                @blur="filters.start = parseDate(filters.start)" />
                                <v-date-picker v-model="filters.start" no-title @input="startDatepicker = false" @change="fetch(true)" :first-day-of-week="1" :locale="_locale" />
                            </v-menu>
                        </div>
                        <div layout="column" layout-align="start start" flex>
                            {{$t('_.to')}}
                            <v-menu ref="menu2" :close-on-content-click="false" v-model="endDatepicker" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width class="full-width">
                                <v-text-field slot="activator" v-model="endFormatted" :label="$t('_.date_format')" single-line flat outline append-outer-icon="mdi-calendar"
                                @blur="filters.end = parseDate(filters.end)" />
                                <v-date-picker v-model="filters.end" no-title @input="endDatepicker = false" :first-day-of-week="1" @change="fetch(true)" :locale="_locale" />
                            </v-menu>
                        </div>
                    </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('filters.sender_sectors')}}</div>
                    </template>
                    <v-checkbox v-for="s in sectors" hide-details :label="s.text" :value="s.value"
                    v-model="filters.sector"  :key="`sectorfilter_${s.value}`" @change="fetch(true)" class="mt-0 filter-cb pt-0"></v-checkbox>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="exp-ctn">
                    <v-expansion-panel-content class="exp-header">
                    <template slot="header">
                        <div>{{$t('filters.sender_lvs')}}</div>
                    </template>
                    <v-checkbox v-for="l in levels" hide-details :label="l.text" :value="l.value"
                    v-model="filters.level"  :key="`levelfilter_${l.value}`" @change="fetch(true)" class="mt-0 filter-cb pt-0"></v-checkbox>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </div>
        </div>
    </div>
</template>

<script>
    import Messages from '@/api/messages'
    import I18nMixin from '@/mixins/i18n'
    import Consts from '@/consts'
    import ImageMixin from '@/mixins/image'
    import Avatar from '@/components/shared/Avatar.vue'
    import Message from '@/components/shared/Message.vue'
    import FormDataMixin from '@/mixins/formdata'
    import VEmojiPicker from "v-emoji-picker"
    import BeatLoader from "vue-spinner/src/BeatLoader.vue"
    import moment from 'moment'
    import DateField from '@/components/shared/DateField'

    export default {
        mixins: [I18nMixin, ImageMixin, FormDataMixin],
        components: {Avatar, Message, VEmojiPicker, BeatLoader, DateField},
        data () {
            return {
                filters: {
                    keywords: null,
                    is_enabled: null,
                    sector: [],
                    level: [],
                    type:  [],
                    rowsPerPage: 10,
                    descending: 1,
                    sortBy: 'created_at',
                    page: 1,
                    start: null,
                    end: null
                },
                displayFilters: false,
                imgs: {},
                imgsLoad: {},
                startDatepicker: false,
                endDatepicker: false,
                startDatepicker2: false,
                endDatepicker2: false,
                loading: true,
                noMoreData: false,
                bottom: false,
                start: '',
                reports: [],
                processed: []
            }
        },
        created() {
            window.addEventListener('scroll', () => {
                this.bottom = this.bottomVisible()
            })
            this.fetch(true);
        },
        watch: {
            bottom(bottom) {
                if (!this.noMoreData && !this.loading && bottom) {
                    this.filters.page++;
                    this.fetchProcessed()
                }
            },
        },
        methods: {
            fetch (reset = false) {
                if(reset){//On applique un nouveau filtre donc on repart à la 1e page avec de nouveaux messages
                    this.reports = [];
										this.processed = [];
                    this.filters.page = 1;
                    this.noMoreData = false;
										this.fetchReports();
                }

								this.fetchProcessed();
            },
						fetchReports(){
							this.loading = true;
							Messages.getReports(this.filters).then(res => {
									this.loading = false;
									this.reports = res.data;
									this.$store.commit('LOAD_LOGO');
							});
						},
						fetchProcessed(){
							this.loading = true;
							Messages.getProcessed(this.filters).then(res => {
									this.loading = false;

									if(res.data && res.data.length){
											for(let i = 0; i < res.data.length; i++){
													this.processed.push(res.data[i]);
											}
									} else{
											this.noMoreData = true;
									}

									if (!this.noMoreData && !this.loading && this.bottomVisible()) {
											this.filters.page++;
											this.fetchProcessed()
									}
							})
						},
            resetFilters () {
                this.filters = {
                    keywords: null,
                    is_enabled: null,
                    sector: [],
                    level: [],
                    rowsPerPage: 10,
                    descending: 1,
                    sortBy: 'created_at',
                    page: 1,
                    start: null,
                    end: null,
                    type: []
                };
                this.fetch(true);
            },
            onDelete(i){
                this.messages.splice(i, 1);
            },
            itemName(item){
                return this.i18n(item.name);
            },
            itemLabel(item){
                return this.i18n(item.label);
            },
            parseDate (date) {
                if (!date) return null;

                if (date.indexOf('-') >= 0) {
                    return date;
                }

                return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
            },
            bottomVisible() {
                const scrollY = window.scrollY
                const visible = document.documentElement.clientHeight
                const pageHeight = document.documentElement.scrollHeight
                const bottomOfPage = visible + scrollY >= pageHeight
                return bottomOfPage || pageHeight < visible
            },
            onStartInput(val){
                this.editingMessage.date_start = val;
            },
        },
        computed: {
            sectors () {
                return [
                    { value: Consts.PRIMARY, text: this.$t('schools.sector_prim') },
                    { value: Consts.SECONDARY, text: this.$t('schools.sector_sec') },
                    { value: Consts.COMPETENCECENTRE, text: this.$t('schools.sector_comp') },
                ]
            },
            levels () {
                return [
                    { value: Consts.MINISTRY, text: this.$t('users.lv_min') },
                    { value: Consts.NATIONAL, text: this.$t('users.lv_nat') },
                    { value: Consts.SECTORAL, text: this.$t('users.lv_sec') },
                    { value: Consts.LOCAL, text: this.$t('users.lv_loc') },
                ]
            },
            types () {
                return [
                    { value: Consts.EVENT, text: this.$t('messages.evts'), icon: 'calendar' },
                    { value: Consts.SURVEY, text: this.$t('messages.surveys'), icon: 'clipboard-text' },
                    { value: Consts.CIRCLE, text: this.$t('messages.int_msgs'), icon: 'set-none' },
                    { value: Consts.PLATFORM, text: this.$t('messages.public_msgs'), icon: 'send' },
                    { value: Consts.TOPDOWN, text: this.$t('messages.topdowns'), icon: 'arrow-expand-down' },
                    { value: Consts.BOTTOMUP, text: this.$t('messages.bottomups'), icon: 'arrow-expand-up' },
                ]
            },
            startFormatted: {
                get () {
                    return this.filters.start ? this.formatDateI18n(this.filters.start) : null;
                },
                set (x) {
                    this.$emit('input', x);
                }
            },
            endFormatted: {
                get () {
                    return this.filters.end ? this.formatDateI18n(this.filters.end) : null;
                },
                set (x) {
                    this.$emit('input', x);
                }
            },
        },
    }
</script>
<style>
.exp-header > .v-expansion-panel__header > div {
  margin-left: 5px;
  font-weight: bold;
}
.exp-header
  > .v-expansion-panel__header
  > .v-expansion-panel__header__icon
  > .v-icon {
  position: absolute;
  left: 0;
  margin-left: 0px;
  margin-right: 5px;
  top: 12px;
  font-weight: bold;
}
.exp-ctn {
  box-shadow: none;
}
.filter-cb > .v-input__control > .v-input__slot > .v-label {
  font-size: 14px;
  color: black;
}
</style>
<style scoped>
@media screen and (min-width: 960px) {
  .messages-col {
    margin-right: 40px;
    margin-left: 30px;
  }
}
</style>